import '.i{position:fixed;}.ssr-plugin'
import '.ct{top:0px;}.ssr-plugin'
import '.bg{left:0px;}.ssr-plugin'
import '.bh{right:0px;}.ssr-plugin'
import '.g0{bottom:0px;}.ssr-plugin'
import '.g1{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.g2{z-index:998;}.ssr-plugin'
import '.g3{transition:opacity 0.3s ease;}.ssr-plugin'
import '.s{height:100vh;}.ssr-plugin'
import '.x{width:100%;}.ssr-plugin'
import '.ad{background-color:var(--palette-white);}.ssr-plugin'
import '.g4{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.g5{z-index:999;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.y{justify-content:space-between;}.ssr-plugin'
import '.bs{padding:1.5rem;}.ssr-plugin'
import '.g6{border-bottom:var(--border-default);}.ssr-plugin'
import '.bl{flex-shrink:0;}.ssr-plugin'
import '.bk{flex:1;}.ssr-plugin'
import '.ay{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="i ct bg bh g0 g1 g2 g3"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="i ct s x ad g4 g5 d e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="d v y bs g6 bl"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="bk ay bs"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
